// import { Popover, Transition } from "@headlessui/react";
// import React, { Fragment, useRef, useState } from "react";
// import iconArrowBox from "../../../assets/svg/arrow-box-secret.svg";
// function NotificationsPopover({ badge, openNotificationDrawer }) {
//   let timeout; // NodeJS.Timeout
//   const timeoutDuration = 400;

//   const buttonRef = useRef(null); // useRef<HTMLButtonElement>(null)
//   const [openState, setOpenState] = useState(false);

//   const toggleMenu = (open) => {
//     // log the current open state in React (toggle open state)
//     setOpenState((openState) => !openState);
//     // toggle the menu by clicking on buttonRef
//     buttonRef?.current?.click(); // eslint-disable-line
//   };

//   // Open the menu after a delay of timeoutDuration
//   const onHover = (open, action) => {
//     // if the modal is currently closed, we need to open it
//     // OR
//     // if the modal is currently open, we need to close it

//     if (
//       (!open && !openState && action === "onMouseEnter") ||
//       (open && openState && action === "onMouseLeave")
//     ) {
//       // clear the old timeout, if any
//       clearTimeout(timeout);
//       // open the modal after a timeout
//       timeout = setTimeout(() => toggleMenu(open), timeoutDuration);
//     }
//     // else: don't click! 😁
//   };
//   const handleClick = (open) => {
//     setOpenState(!open); // toggle open state in React state
//     clearTimeout(timeout); // stop the hover timer if it's running
//   };

//   const handleClickOutside = (event) => {
//     if (buttonRef.current && !buttonRef.current.contains(event.target)) {
//       event.stopPropagation();
//     }
//   };
//   React.useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   });

//   return (
//     <div className="px-4">
//       {badge > 0 ? (
//         <button
//           onClick={() => openNotificationDrawer()}
//           className="inline-block relative bg-white py-2 "
//         >
//           <IcNotification />
//           {/* <span className="animate-ping absolute top-1 right-0.7 block h-2 w-2 rounded-full ring-2 ring-green-400 bg-green-600"></span> */}
//           <span className="absolute top-1 -right-1  flex h-3 w-3 items-center justify-center">
//             <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-300 opacity-75"></span>
//             <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500 items-center justify-center text-[8px] text-white ">
//               {badge}
//             </span>
//           </span>
//         </button>
//       ) : (
//         <Popover className="relative">
//           {({ open }) => (
//             <div
//               onMouseEnter={() => onHover(open, "onMouseEnter")}
//               onMouseLeave={() => onHover(open, "onMouseLeave")}
//             >
//               <Popover.Button
//                 ref={buttonRef}
//                 className={`
//                 ${open ? "" : "text-opacity-90"}
//                 group inline-flex items-center rounded-md bg-white  py-3 text-base font-medium text-white hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
//               >
//                 <div
//                   onClick={() => {
//                     handleClick(open);
//                     openNotificationDrawer();
//                   }}
//                 >
//                   <IcNotification />
//                 </div>
//               </Popover.Button>
//               <Transition
//                 as={Fragment}
//                 enter="transition ease-out duration-200"
//                 enterFrom="opacity-0 translate-y-1"
//                 enterTo="opacity-100 translate-y-0"
//                 leave="transition ease-in duration-150"
//                 leaveFrom="opacity-100 translate-y-0"
//                 leaveTo="opacity-0 translate-y-1"
//               >
//                 <Popover.Panel className="absolute left-1/2 z-10 mt-6 w-44 max-w-sm -translate-x-1/2 transform px-4 sm:px-0 ">
//                   <div className="overflow-hidden flex rounded-md shadow-lg justify-center items-center py-2 px-4 bg-white text-base text-[#424242] text-center ">
//                     <img
//                       className="absolute -top-3 drop-shadow-10xl "
//                       src={iconArrowBox}
//                       alt="iconArrowBox"
//                     />
//                     <span>پیام جدیدی ندارید</span>
//                   </div>
//                 </Popover.Panel>
//               </Transition>
//             </div>
//           )}
//         </Popover>
//       )}
//     </div>
//   );
// }

// export default NotificationsPopover;
import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import IcNotification from "../iconComponents/IcNotification";

const useStyles = makeStyles((theme) => ({
  arrow: {
    "&:before": {
      border: "1px solid #E6E8ED",
    },
    color: theme.palette.common.white,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #E6E8ED",
    color: "#4A4A4A",
  },
}));

function NotificationsPopover({ badge, openNotificationDrawer }) {
  let classes = useStyles();
  return (
    <Tooltip
      arrow
      classes={{ arrow: classes.arrow, tooltip: classes.tooltip }}
      title={
        <div className="flex  items-center px-1">
          {badge > 0 ? (
            <span dir="rtl" className="text-[#1A1919]  text-base">
              {badge + " "}پیام جدید دارید
            </span>
          ) : (
            <span className="text-[#1A1919] text-base">پیام جدیدی ندارید</span>
          )}
        </div>
      }
    >
      <div className="px-4 ">
        <button onClick={() => openNotificationDrawer()} className="bg-white py-2  inline-block relative ">
          <IcNotification />
          {badge > 0 && (
            <span className="absolute top-1 -right-1  flex h-3 w-3 items-center justify-center">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-300 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500 items-center justify-center text-[8px] text-white ">
                {badge}
              </span>
            </span>
          )}
        </button>
      </div>
    </Tooltip>
  );
}

export default NotificationsPopover;
